require([
    'jquery',
    'base/MbiHelper',
    'gmaps',
    'base/MbiImageSize'
], function(
    $,
    _,
    GMaps,
    mbiImageSize
    ) {
    'use strict'

var $urlPrefix = '';
function loadMap() {
    if(_.exists('#map')) {
    var map = new GMaps({
        el: '#map',
        lat: $('#map').attr('data-lat'),
        lng: $('#map').attr('data-lng'),
        scrollwheel: false,
        panControl : false,
        streetViewControl : false,
        mapTypeControl: false,
        scaleControl: false,
        overviewMapControl: false,
        draggable: false,
        navigationControl: false,
        disableDoubleClickZoom: true,
        zoomControl: false,
        zoom: 8
      });

var markers = [];
    // var markers = [
    //     {
    //         lat: 46.829237,
    //         lng: 12.767564,
    //         title: 'Lima',

    //     }];

var standard = {
    url: $urlPrefix + '/Assets/Images/marker1.png',
    // This marker is 20 pixels wide by 32 pixels high.
    // size: new google.maps.Size(20, 32),
    // The origin for this image is (0, 0).
    // origin: new google.maps.Point(0, 0),
    // // The anchor for this image is the base of the flagpole at (0, 32).
    // anchor: new google.maps.Point(0, 0)
  };
var kaffee = {
    url: $urlPrefix + '/Assets/Images/coffee.png',
  };
var apotheke = {
    url: $urlPrefix + '/Assets/Images/apotheke.png',
  };
var ubahn = {
    url: $urlPrefix + '/Assets/Images/ubahn.png',
  };

$('.marker').each(function(e, f){
    if($('html').attr('data-browser-name') == 'ie') {
        var image = {
            url: $urlPrefix + '/Assets/Images/map/png/'+$(this).attr('data-style')+'.png'
        }
    } else {
        var image = {
            url: $urlPrefix + '/Assets/Images/map/'+$(this).attr('data-style')+'.svg'
        }
    }
    // switch($(this).attr('data-style')) {
    //     case 'kaffee':
    //         var image = {
    //             url: $urlPrefix + '/Assets/Images/ubahn.png'
    //         }
    //         break;
    //     case 'apotheke':
    //         var image = {
    //             url: $urlPrefix + '/Assets/Images/ubahn.png',
    //         }
    //     case 'ubahn':
    //         var image = {
    //             url: $urlPrefix + '/Assets/Images/ubahn.png',
    //         }
    //     default:
    //         var image = {
    //             url: $urlPrefix + '/Assets/Images/kaffee.png'
    //         }
    //     break;
    // }


        markers.push({
            lat: $(this).attr('data-lat'),
            lng: $(this).attr('data-lng'),
            title: $(this).attr('data-name'),
            icon: image
        });


    // console.log($(this)attr('lat'));
});

$('.gm-style-iw').parent().parent().addClass('info-gmaps');
        // $('.marker').tooltipster({
        //     trigger: 'hover', // default is 'hover' which is no good here
        //     onlyOne: false,    // allow multiple tips to be open at a time
        //     timer: 0,
        //     position: 'left',  // display the tips to the right of the element
        //     offsetY: 0,
        //     theme: 'light',
        //     content: $(this).attr('data-name')
        // });

// $(element).tooltipster('update', $(error).text());
                // $(element).tooltipster('show');
        var styles = [{
              "featureType": "all",
              "elementType": "all",
              "stylers": [{
                "hue": "#869CA8"
              }, {
                "saturation": 0
              }]
            }, {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [{
                "visibility": "simplified"
              }, {
                "lightness": 100
              }]
            }, {
              "featureType": "road",
              "elementType": "labels",
              "stylers": [{
                "visibility": "off"
              }]
            }]

        map.addStyle({
            styledMapName:"Styled Map",
            styles: styles,
            mapTypeId: "map_style"
        });

        map.setStyle("map_style");

    map.addMarkers(markers);
    }

    }


    setTimeout(function(){
        $(document).find('.gm-style-iw').parent().parent().addClass('info-gmaps');
    },600);
    loadMap();
});
define("root/Assets/Templates/Html/maps/Js/maps", function(){});

